// Suave Perfumes — mobile filter UX fix
// If there is only ONE filter category (e.g. "Gender & seasons"), skip the
// intermediate category list and open the options list directly, so the
// customer doesn't see an empty screen with just one line on it.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mobile-facets__disclosure').forEach(function (drawer) {
    drawer.addEventListener('toggle', function () {
      if (!drawer.open) return;
      var mainMenu = drawer.querySelector('#FacetsWrapperMobile');
      if (!mainMenu) return;
      var categories = mainMenu.querySelectorAll(':scope > .mobile-facets__details');
      if (categories.length === 1) {
        var onlyCategory = categories[0];
        var summary = onlyCategory.querySelector('summary');
        if (summary && !onlyCategory.open) {
          summary.click();
        }
      }
    });
  });
});
